<template>
  <div class="panelContainer">
    <div class="panelBody">
      <div class="flightDetails__time_total">
        <span class="flightDetails__duration"
          >{{ $t('shopping_lib.flight_time_total') }}
          <i class="fas fa-clock mr-2"></i
          ><b>{{ flightDetail.travel_time | minutesFormatPipe }}</b></span
        >
      </div>
      <flightSegmentDetail
        class="flightDetails"
        v-for="(detail, index) in parseFlightDetail(flightDetail.flight_detail)"
        :segmentDetail="detail"
        :key="index"
      >
      </flightSegmentDetail>
    </div>
  </div>
</template>

<script>
import flightSegmentDetail from './flightSegmentDetail.vue'
import moment from 'moment'
import filters from '../../helpers/filters'

export default {
  name: 'flightDetails',
  components: {
    flightSegmentDetail,
  },
  mixins: [filters],
  props: {
    flightDetail: {
      type: Object,
      required: true,
    },
  },
  methods: {
    parseFlightDetail: function (detail) {
      for (let i = 0; i < detail.length; i++) {
        const flightDetail = detail[i]
        flightDetail.connection_time = this.formatMinutesToHours(
          flightDetail.connection_time
        )
        flightDetail.journey_duration = this.formatMinutesToHours(
          flightDetail.journey_duration
        )
      }
      return detail
    },
    formatMinutesToHours: function (minutes) {
      if (!minutes) return null
      const duration = moment.duration(minutes, 'minutes')
      const formattedTime = moment
        .utc(duration.asMilliseconds())
        .format('HH:mm')
      return formattedTime
    },
  },
}
</script>
<style lang="sass" scoped>
.flightDetails
  display: flex
  font-size: var(--font-size-sm)
  justify-content: center
  width: 100%
  padding: 1rem
  flex-direction: column
  position: relative
.flightDetails__duration
  border-radius: var(--b-radius-d1)
  background-color: var(--color-overlay-05)
  align-items: center
  color: var(--color-primary)
  font-size: var(--font-size-sbase)
  padding: 0.2rem 1rem
.flightDetails__time_total
  margin-top: 1rem
  display: flex
  justify-content: center
</style>
